import Vue from  'vue'
import ArrayManipulation from '../mixins/ArrayManipulation'
export default Vue.extend({
    mixins: [ArrayManipulation],
    props: {
        element: {
            type: Object,
            required: true
        },
        module: {
            type: String,
            required: true
        },
        parentModule: {
            type: String,
            required: false
        },
    },
})